/**
 * 课程接口
 */
import request from '../request'

const URL = {
  /**
     * 课程
     */
  frontMenuList: '/frontMenu/getFrontMenuByLoginInfo', // 课程顶部视频轮播列表
  /**
     * PPT课程--建国、建党、特色、思政课程
     */
  listOfTopSeries: '/course/findPageOfTopSeries', // 课程-建国、建党、特色、思政课程下面的列表
  listFilterList: '/series/findChildrenForTree', // 课程-建国、建党、特色、思政课程的内部筛选列表
  chapterIdByCourseId: '/chapter/findListOfCourse', // 课程-建国、建党、特色、思政课程——根据courseId 课程ID 获得chapterId 章节ID
  courseDetailByChapterId: '/course/findCourseDetailByChapterId', // 课程-建国、建党、特色、思政课程——根据chapterId 章节ID查询章节所属课程的详细信息（包括课程的各章节列表）
  courseDetails: '/page/findList', // 根据chapterId 章节ID查询该章节所有的ppt页，ppt按照第几张升序排序
  relativeList: '/chapter/findChapterResources', // 相关推荐

  /**
     * 场景专区-vr专区
     */
  forVRSpecial: '/vrScene/findPageForVrSpecial', // vr专区 场景模块  获取场景列表分页
  /**
     * 全景专区
     */
  forVRPanorama: '/vrPanorama/findPage', // 全景专区  获取全景列表分页
  /**
     * 模型专区
     */
  pageForVrSpecial: '/libModel/findPageForVrSpecial', // 模型专区  获取模型列表分页
  modelRelaticeList: '/libModel/findPageForVrSpecialOther', // 根据模型id查看相关推荐
  modelDetails: '/libModel/findByIdForVrSpecial', // 根据模型id查看详情
}
const news = {
  /**
   * 课程
   */
  // 课程顶部视频轮播
  getFrontMenuList () {
    return request.get(URL.frontMenuList)
  },
  /**
   * PPT课程--建国、建党、特色、思政课程
   */
  // 课程-党建课程下面的列表
  getListOfTopSeries (reqData) {
    return request.put(URL.listOfTopSeries, reqData)
  },
  // 课程-建国、建党、特色、思政课程的内部筛选列表
  getFilterList (id) {
    return request.get(URL.listFilterList + '/' + id)
  },
  // 根据courseId 课程ID 章节ID查询 各章节列表Tab
  getChapterIdByCourseId (id) {
    return request.get(URL.chapterIdByCourseId + '/' + id)
  },
  // 根据chapterId 获得章节所属课程的详细信息
  getCourseDetailByChapterId (id, reqData) {
    return request.get(URL.courseDetailByChapterId + '/' + id, reqData)
  },
  // 根据chapterId 章节ID查询该章节所有的ppt页，ppt按照第几张升序排序
  getCourseDetails (id, reqData) {
    return request.get(URL.courseDetails + '/' + id, reqData)
  },
  // 获取相关推荐
  getRelativeList (id, modelId, reqData) {
    return request.get(URL.relativeList + '/' + id + '/' + modelId, reqData)
  },
  // 根据模型id查看相关推荐
  getModelRelaticeList (reqData) {
    return request.put(URL.modelRelaticeList, reqData)
  },
  // 根据模型id查看详情
  getModelDetails (id) {
    return request.get(URL.modelDetails + '/' + id)
  },

  /**
   * 场景专区-vr专区
   */
  // 场景专区 场景模块  获取场景列表分页
  getForVRSpecial (reqData) {
    return request.put(URL.forVRSpecial, reqData)
  },
  /**
   * 全景专区
   */
  // 全景专区  获取全景列表分页
  getPannoPageList (reqData) {
    return request.put(URL.forVRPanorama, reqData)
  },
  /**
   * 模型专区
   */
  // 全景专区  获取全景专区列表分页
  getModalList  (reqData) {
    return request.put(URL.pageForVrSpecial, reqData)
  },

}
export default news
